import { useState } from "react";
import { pipSaveLoginRole } from "../../utils/pip";
import { pageRoutes } from "../../routes/pageRoutes";
import { useLocation, useNavigate } from "react-router-dom";
import { BASE_URL, googleLogin } from "../../routes/apiEndPoints";

const Login = () => {
  const navigate = useNavigate();
  const [selectedRole, setSelectedRole] = useState("");
  const data = useLocation()?.state?.data || "dashboard";

  console.log(
    `${BASE_URL}${googleLogin}${selectedRole}${
      selectedRole == "student" ? "" : data
    }`
  );
  return (
    <>
      <div className="main-content- h-100vh position-relative ct_login_main_bg">
        <div className="container">
          <div className="row">
            <div className="col-md-10 mx-auto">
              <div className=" ct_login_section_col_2 h-100 ">
                <div className="ct_login_left_img">
                  <img src="images/login_left_img_12.png" />
                </div>
                <div className="ct_right_login_form position-relative">
                  <div className="mb-4">
                    <a
                      className="navbar-brand ct_logo_text ct_fs_16 et_back_btn "
                      href="javascript:void(0)"
                      onClick={() => navigate(pageRoutes?.home)}
                    >
                      <i className="fa-solid fa-arrow-left"></i> Back
                    </a>
                  </div>
                  <h4 className="ct_fs_44 ct_fw_600">Let the Journey Begin!</h4>
                  <p className="mb-0">
                    Unlock a world of education with a single click! Please
                    login in to your account.
                  </p>
                  <form className="mt-4 pt-2">
                    <div className="form-group mb-3">
                      <div>
                        <label
                          htmlFor="inlineRadio1"
                          class="form-check ct_radio_style ct_custom_btn1 ct_outline_btn_12 w-100 ct_multiple_radio_select"
                        >
                          <label
                            htmlFor="inlineRadio1"
                            class="form-check-label  ct_fs_16 mb-0"
                            style={{ cursor: "pointer" }}
                          >
                            Sign in as Student
                          </label>
                          <input
                            class="form-check-input"
                            type="radio"
                            name="inlineRadioOptions"
                            id="inlineRadio1"
                            value="student"
                            onChange={() => setSelectedRole("student")}
                            checked={selectedRole === "student"}
                          />
                        </label>
                        <label
                          htmlFor="inlineRadio2"
                          class="form-check ct_custom_btn1 w-100 ct_outline_btn_12 ct_multiple_radio_select"
                        >
                          <label
                            htmlFor="inlineRadio2"
                            class="form-check-label ct_fs_16 mb-0"
                            style={{ cursor: "pointer" }}
                          >
                            Sign in as Teacher
                          </label>
                          <input
                            class="form-check-input"
                            type="radio"
                            name="inlineRadioOptions"
                            id="inlineRadio2"
                            value="teacher"
                            onChange={() => setSelectedRole("teacher")}
                            checked={selectedRole === "teacher"}
                          />
                        </label>
                      </div>

                      <div id="signInButton" className="mt-4">
                        {selectedRole && (
                          <div class="form-group mb-3 mt-4">
                            <button
                              class="ct_custom_btn1 w-100 ct_outline_btn_12 ct_fw_600 d-flex align-items-center justify-content-center gap-2"
                              type="button"
                              onClick={() => {
                                pipSaveLoginRole(
                                  `${selectedRole}${selectedRole == "student"
                                    ? ""
                                    : data}`
                                );
                                window.location.href = `${BASE_URL}${googleLogin}${selectedRole}`;
                              }}
                            >
                              <img
                                src="img/google_icon.png"
                                alt=""
                                width="20px"
                              />
                              Sign in with Google
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
